module.exports = __webpack_public_path__ + "img/famas.64e8a828.svg";